<template>
	<el-card class="rechargepay">
		<el-form ref="form" :model="form" label-width="120px">
			<el-form-item label="充值账户：">{{ form.company }} </el-form-item>
			<el-form-item label="账户余额："> {{ form.amount }} 元</el-form-item>
			<el-form-item label="充值金额："
				><el-input-number v-model="num" :precision="2" :min="0" :step="1" :controls="false"></el-input-number>
				元
			</el-form-item>
			<el-form-item :label="`充值${$MONEY_NAME}：`"> {{ num }} {{ $MONEY_NAME }}</el-form-item>
		</el-form>
		<div class="recharge" @click="recharge">充值</div>
	</el-card>
</template>

<script>
import { userInfo } from '@/utils/api'
import { mabangPay } from '@/utils/constant'
import { Message } from 'element-ui'
export default {
	data() {
		return {
			form: {
				amount: 0, //余额
				company: '',
			},
			num: 0,
		}
	},
	mounted() {
		this.getuserInfo()
	},
	methods: {
		//充值
		recharge() {
			if (!this.num) {
				Message.error({ message: '充值金额不能为0或空！' })
				return
			}
			let params = {
				recharge: 1,
				buyNum: this.num,
			}
			mabangPay(params)
		},
		//获取账户信息
		getuserInfo() {
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			userInfo(params).then((res) => {
				this.form = { ...res }
			})
		},
	},
}
</script>

<style scoped>
.rechargepay {
	min-height: 100%;
	box-sizing: border-box;
}
.recharge {
	width: 57px;
	height: 28px;
	background: #003366;
	color: #ffffff;
	line-height: 28px;
	text-align: center;
	cursor: pointer;
	margin-left: 25px;
	font-size: 12px;
	border-radius: 5px;
}
</style>
